// const echarts = require('echarts')
export default {
  grid: {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
  xAxis: {
    min: 0,
    max: 1920,
    show: false,
    type: 'value'
  },
  yAxis: {
    min: 0,
    max: 1080,
    show: false,
    type: 'value'
  },
  animationDurationUpdate: 1500,
  animationEasingUpdate: 'quinticInOut',
  series: [{
    type: 'lines',
    polyline: true,
    coordinateSystem: 'cartesian2d',
    lineStyle: {
      // type: [8, 4],
      width: 3,
      color: 'rgba(0, 197, 255, 1)',
      opacity: 0.95
    },
    effect: {
      show: true,
      constantSpeed: 150,
      trailLength: 0,
      symbol: 'image://http://app.liuhuanhong.com/assets/img_lightspot_b.png',
      // symbol: 'circle',
      symbolSize: 10,
      color: '#40DDBF'
    },
    data: []
    // data: [
    //   {
    //     coords: [
    //       [258, 373],
    //       [363, 430],
    //       [100, 585],
    //       [318, 718]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [363, 430],
    //       [215, 518],
    //       [435, 650]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [363, 430],
    //       [373, 424],
    //       [613, 558]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [363, 430],
    //       [560, 316],
    //       [800, 460]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [363, 430],
    //       [690, 241],
    //       [912, 377]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [363, 430],
    //       [855, 145],
    //       [1090, 280]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [363, 430],
    //       [1048, 32],
    //       [1275, 175]
    //     ]
    //   }, { // 第三排
    //     coords: [
    //       [258, 373],
    //       [725, 629],
    //       [512, 755],
    //       [692, 867]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [725, 629],
    //       [612, 696],
    //       [797, 809]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [725, 629],
    //       [710, 639],
    //       [905, 748]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [725, 629],
    //       [812, 578],
    //       [1011, 702]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [725, 629],
    //       [940, 503],
    //       [1140, 628]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [725, 629],
    //       [1107, 405],
    //       [1318, 529]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [725, 629],
    //       [1307, 290],
    //       [1500, 400]
    //     ]
    //   }, { // 第四排
    //     coords: [
    //       [258, 373],
    //       [1087, 828],
    //       [1225, 747],
    //       [1458, 882]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [1087, 828],
    //       [1360, 670],
    //       [1584, 802]
    //     ]
    //   }, {
    //     coords: [
    //       [258, 373],
    //       [1087, 828],
    //       [1460, 610],
    //       [1697, 746]
    //     ]
    //   },

    //   // 其他点 第一排
    //   {
    //     coords: [
    //       [380, 292],
    //       [490, 357]
    //     ]
    //   }, {
    //     coords: [
    //       [500, 238],
    //       [598, 295]
    //     ]
    //   },

    //   // 其他点 第二排
    //   {
    //     coords: [
    //       [363, 743],
    //       [452, 790]
    //       // [512, 755]
    //     ]
    //   }, {
    //     coords: [
    //       [480, 675],
    //       [564, 725]
    //     ]
    //   }, {
    //     coords: [
    //       [658, 583],
    //       [733, 625]
    //     ]
    //   }, {
    //     coords: [
    //       [845, 485],
    //       [907, 523]
    //     ]
    //   }, {
    //     coords: [
    //       [957, 402],
    //       [1033, 448]
    //     ]
    //   }, {
    //     coords: [
    //       [1135, 305],
    //       [1209, 347]
    //     ]
    //   }, {
    //     coords: [
    //       [1320, 200],
    //       [1390, 244],
    //       [1307, 290]
    //     ]
    //   },

    //   // 其他点 第三排
    //   {
    //     coords: [
    //       [737, 892],
    //       [855, 963],
    //       [1360, 670]
    //     ]
    //   }, {
    //     coords: [
    //       [842, 834],
    //       [963, 900],
    //       [1360, 670]
    //     ]
    //   }, {
    //     coords: [
    //       [950, 773],
    //       [1068, 840]
    //     ]
    //   }, {
    //     coords: [
    //       [1056, 727],
    //       [1158, 788]
    //     ]
    //   }, {
    //     coords: [
    //       [1185, 653],
    //       [1285, 715]
    //     ]
    //   }, {
    //     coords: [
    //       [1363, 554],
    //       [1460, 610]
    //     ]
    //   }, {
    //     coords: [
    //       [1545, 425],
    //       [1660, 495],
    //       [1460, 610]
    //     ]
    //   }
    // ]
  }]
}
